import { logger } from '@utils';
import axios, { AxiosRequestConfig } from 'axios';

interface RequestOptions extends AxiosRequestConfig {
  silent?: boolean;
}

export const request = async (route: string, options?: RequestOptions) => {
  const url = `${route}`;
  const requestLog = `${options && options.method ? options.method : 'GET'} ${url}`;

  // Only log if not in silent mode (following existing logging patterns)
  if (!options?.silent) {
    logger.info(`${requestLog}`);
    if (options) {
      logger.debug(`[Request options]: ${JSON.stringify(options, null, 2)}`);
    }
  }

  // Extract silent option and pass the rest to axios (following existing options pattern)
  const { silent, ...axiosOptions } = options || {};

  const requestBody: AxiosRequestConfig = {
    ...axiosOptions,
    method: axiosOptions?.method ? axiosOptions.method : 'GET',
    url: url,
  };

  const response = await axios(requestBody);

  if (response) {
    return response;
  }
};
